import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {DbResponse} from "../../shared/interceptors/db-response";
import {NotifierComponent} from "../../shared/components/notifier/notifier.component";
import {Notification} from "../../shared/components/notifier/notification";
import {NotificationType} from "../../shared/components/notifier/notification-type";
import {UserSubscription, UserSubscriptionCategory, UserSubscriptionType} from "../../user/user-subscription";
import {UserSubscriptionStatus} from "../../user/user-subscription-status";
import {CancelSubscriptionComponent} from "../cancel-subscription/cancel-subscription.component";
import {DialogService} from "../../../ng2-bootstrap-modal/dialog.service";
import {SearchByPropertyPipe} from "../../shared/pipes/search-by-property.pipe";
import {combineLatest, Subscription} from 'rxjs';
import {PaymentDialogComponent} from "../billing/payment-dialog/payment-dialog.component";
import * as fromStore from '../../store';
import {Store} from '@ngrx/store';
import {filter, first, switchMap, takeUntil} from 'rxjs/operators';
import {User} from "../../user/user";
import {TextUtils} from "../../shared/utils/text-utils";
import {
  CouponApplyResponseDialogComponent
} from "./coupon-apply-respoonse-dialog/coupon-apply-response-dialog.component";
import {Utils} from "../../shared/utils/utils";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {WorkspaceService} from "../workspace.service";
import {Subject} from "rxjs";
import {clientRoles} from "../../user/user-roles-actions";
import {Payment} from "../../user/payment";
import {DbModalService} from "../../modules/modal/modal";
import {Location} from '@angular/common';
import {Config} from "../../config/config";
import {AddPaymentMethodComponent} from "../billing/add-payment-method/add-payment-method.component";
import {Product} from "../../websites/website/product";
import {PaymentMethod} from "../../user/payment-method";
import {GoogleAnalyticsService} from "../../shared/services/google-analytics/google-analytics.service";
import {TypeUtils} from "../../shared/utils/type-utils";
import {CookieService} from "ngx-cookie";
import {AuthService} from "../../auth/auth.service";
import {
  NotificationDialogComponent
} from "../../shared/components/dialogs/notification-dialog/notification-dialog.component";
import {CancelSubscriptionWithNoPaymentComponent} from "./dialogs/cancel-subscription-no-payments.component";
import {
  ConfirmDowngradeAgreementComponent
} from "../../websites/website/ecommerce/dialogs/confirm-downgrade-agreement/confirm-downgrade-agreement.component";
import {UserService} from "../../user/user.service";
import {
  PricingPageViewComponent
} from "../../shared/components/dialogs/one-month-free/components/pricing-page-view/pricing-page-view.component";
import {ConfirmDialogComponent} from "../../shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import {LanguageService} from "../../shared/services/language/language.service";

const SECONDARY_SUBSCRIPTION_TYPES = [
  UserSubscriptionType.ONE_PRODUCT,
  UserSubscriptionType.PREMIUM,
];

@Component({
    selector: 'db-subscription-plan',
    templateUrl: './subscription-plan.component.html',
    styleUrls: ['./subscription-plan.component.scss'],
    standalone: false
})
export class SubscriptionPlanComponent implements OnInit, OnDestroy {

  @Input() userSubscription: UserSubscription;
  @Input() activateAddOn: any;
  @Input() annualPrice: number;
  @Output() unpause?: EventEmitter<boolean> = new EventEmitter<boolean>();

  public userSubscriptionStatus: typeof UserSubscriptionStatus = UserSubscriptionStatus;
  private subscriptions: Subscription[];
  public user: User;
  public loading: boolean;
  public upgradeSubscription: UserSubscription;
  public annualSubscription: UserSubscription;
  public monthlyPrice: number;
  public annualPriceForCurrent: number;
  public promoCode: any = '';
  public userSubscriptionStorage: number;
  public userSubscriptionVisits: number;
  public UserSubscriptionType: any = UserSubscriptionType;
  public aiStarterAnnual: UserSubscription;
  public booster: boolean;
  public trialDeleteDay: any;
  public _trialDeleteDay: any;
  public twCareLink: string = Config.twCareLink;
  public currentWorkspaceRole: number;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();
  public workspaceRoles = clientRoles;
  public UserSubscriptionCategory = UserSubscriptionCategory;
  public payments: Payment[];
  public permanentShowCancelButton: boolean;
  public paymentMethods: PaymentMethod[];
  public hasUpgrade: boolean;
  public activateClicked: boolean;
  public isTier1Country: boolean;
  public userLocalStorage: any;
  public englishCountries: boolean;
  public nextPaymentDate: Date = new Date();
  public emailCampaignExtend = false;
  public emailCampaignExtendWithCoupon = false;
  public couponPrefixForDowngradeToBase = false;
  public couponPrefixForDowngradeToTrial = false;
  isDemoUser = false;
  isAiDemoUser = false;
  campaignInfo: any;
  companyInfo: any;
  private _stripe: any;
  checkoutElement: any;
  public isPayPalProvider: boolean = false;
  public paypalSetupToken: string;
  public loadingStripe: boolean;
  public stripeErrors: any;

  protected readonly Config = Config;

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _dialogService: DialogService,
    private _searchByPropertyPipe: SearchByPropertyPipe,
    private _router: Router,
    private _location: Location,
    private _authService: AuthService,
    private _userService: UserService,
    private _workspaceService: WorkspaceService,
    private _route: ActivatedRoute,
    private _dbModal: DbModalService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _cookieService: CookieService,
    private _languageService: LanguageService
  ) {
  }

  ngOnInit() {
    this.campaignInfo = this._userService.getCampaignInfo();
    this.userSubscription?.plan?.hasDomainService && this._store.dispatch(new fromStore.LoadPurchasedDomains());
    const queryParams: any = (<any>this._route.queryParams).value;
    if (queryParams?.dbCouponFromEmail) {
      this.emailCampaignExtend = queryParams?.dbCouponFromEmail.indexOf(Config.couponPrefixForExtend) > -1;
      this.emailCampaignExtendWithCoupon = queryParams?.dbCouponFromEmail.indexOf(Config.couponPrefixForExtendWithCoupon) > -1;
      this.couponPrefixForDowngradeToBase = queryParams?.dbCouponFromEmail.indexOf(Config.prefixForDowngradeToBase) > -1;
      this.couponPrefixForDowngradeToTrial = queryParams?.dbCouponFromEmail.indexOf(Config.prefixForDowngradeToTrial) > -1;
    }
    const downgradeTo = this.couponPrefixForDowngradeToTrial ? 'trial' : 'base';
    (this.couponPrefixForDowngradeToBase || this.couponPrefixForDowngradeToTrial) && this.downgradeAgreementPopup(downgradeTo);
    const queryParamsIndex: number = this._router.url.indexOf('?');
    if (queryParams && queryParams.update_subscr) {
      this.loadData(true);
    }
    if (queryParamsIndex !== -1) {
      this._location.replaceState(this._router.url.substring(0, queryParamsIndex));
    }
    const payments = this._route.snapshot.data['payments'];
    this.payments = payments && payments.length ? payments.filter((payment) => payment.paymentStatus !== 'failed') : [];
    this._store.select(fromStore.getWorkspaceIdEntities)
      .pipe(
        filter(workspaceIdEntities => !!workspaceIdEntities.currentWorkspaceRoleId),
        takeUntil(this._destroyStream$)
      )
      .subscribe(workspaceIdEntities => {
        this.currentWorkspaceRole = workspaceIdEntities.currentWorkspaceRoleId;
      });
    this.loadData();
    this.addEventHandlers();
    this.getPaymentMethods();
    this._getCompanyInfo();
    const getExperimentalCookie = this._cookieService.get('db-experiment');
    this.isTier1Country = getExperimentalCookie ? JSON.parse(getExperimentalCookie) && JSON.parse(getExperimentalCookie).t1PExp && JSON.parse(getExperimentalCookie).t1PExp === 'b' : false;
  }

  public loadData(updateCache: boolean = false): void {
    this.loading = true;
    if (updateCache) {
      this._store.dispatch(new fromStore.UpdateUserSubscription());
      this._store.dispatch(new fromStore.LoadUserLocalStorage());
      this._store.dispatch(new fromStore.LoadUserPayments());
    }

    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getUser),
          this._store.select(fromStore.getUserSubscription),
          this._store.select(fromStore.getUserLocalStorage),
          this._store.select(fromStore.getUserAvailableHostingSubscriptions('platform')),
          this._store.select(fromStore.getPayments),
           ))
      )
      .subscribe(([user, data, userLocalStorage, availableSubscriptions, payments]) => {
        this.loading = false;
        this.user = user;
        this.userSubscription = data;
        this.userLocalStorage = userLocalStorage;
        this.payments = payments ? payments.filter(payment => payment.paymentStatus === 'Confirmed') : [];
        this.isDemoUser = false;
        this.isAiDemoUser = Utils.isDemoUser(this.userSubscription, this.user);
        const category = this.userSubscription && this.userSubscription.isBusiness ? UserSubscriptionCategory.ENTERPRISE : UserSubscriptionCategory.PREMIUM;
        this.annualSubscription = availableSubscriptions.find(userSubscription =>
          userSubscription && this.userSubscription && userSubscription.category && userSubscription.category === category
          && userSubscription.tabCategory && userSubscription.tabCategory === this.userSubscription.tabCategory
          && userSubscription.plan && userSubscription.plan.periodNumber && userSubscription.plan.periodNumber === 12
        );

        if (this.userSubscription && this.userSubscription.platformPaidClient) {
          const annualPlanForCurrent = availableSubscriptions.find(userSubscription =>
            userSubscription && userSubscription.plan && userSubscription.id === Number(this.userSubscription.coupleId) && userSubscription.category === this.userSubscription.category &&
            userSubscription.plan.periodNumber === 12
          );

          this.annualPriceForCurrent = annualPlanForCurrent && annualPlanForCurrent.plan && annualPlanForCurrent.plan.planPrice;
        }

        const monthlyPlan = availableSubscriptions.find(userSubscription =>
          userSubscription && this.userSubscription && userSubscription.category && userSubscription.category === category
          && userSubscription.tabCategory && userSubscription.tabCategory === this.userSubscription.tabCategory
          && userSubscription.plan && userSubscription.plan.periodNumber && userSubscription.plan.periodNumber === 1
        );

        this.monthlyPrice = monthlyPlan && monthlyPlan.plan && monthlyPlan.plan.planPrice;
        this.englishCountries = userLocalStorage && !!userLocalStorage.tier1B;


        this.permanentShowCancelButton = (!!(this.user && this.user.signUpFor && this.user.signUpFor.LastChosenOption
            && this.user.signUpFor.LastChosenOption.answer && ['ai-convert', 'ai-demo-section', 'ai-demo-section-after-signup', 'ai-demo-template', 'ai-demo-template-after-signup'].includes(this.user.signUpFor.LastChosenOption.answer))
          || !!(this.userSubscription && [Config.demoAiPluginId, Config.builder2PluginId].includes(+this.userSubscription.product_id)));
        this.userSubscriptionVisits = this.userSubscription && this.userSubscription.plan && this.userSubscription.plan.services.hosting ?
          parseInt(this.userSubscription.plan.services.hosting.hosting_visits.parameter_value, 10) : 0;

        this.userSubscriptionStorage = this.userSubscription && this.userSubscription.plan && this.userSubscription.plan.services.hosting ? parseInt(this.userSubscription.plan.services.hosting.hosting_storage.parameter_value, 10) : 0;

        this.trialDeleteDay = this.user && this.user.hostingTrialExpirationDate ? Utils.getDaysDiffFromToday(this.user.hostingTrialExpirationDate, true, 'ceil', true, true) : this.userSubscription && this.userSubscription.plan && this.userSubscription.plan.hostingTrialPeriodNumber + ' days';
        this._trialDeleteDay = this.user && this.user.hostingTrialExpirationDate ? Utils.getDaysDiffFromToday(this.user.hostingTrialExpirationDate, false, 'ceil', true, true) : this.userSubscription && this.userSubscription.plan && this.userSubscription.plan.hostingTrialPeriodNumber + ' ';
        if (this._trialDeleteDay < 1) {
          this.trialDeleteDay = 'today';
          this._trialDeleteDay = 'today';
        }
        if (this.userSubscription && this.userSubscription.plan && this._trialDeleteDay > this.userSubscription.plan.hostingTrialPeriodNumber) {
          this.trialDeleteDay = this.userSubscription.plan.hostingTrialPeriodNumber + ' days';
          this._trialDeleteDay = this.userSubscription.plan.hostingTrialPeriodNumber;
        }
      });
  }

  public cancelUserSubscription(): void {
    if (!this.userSubscription || !this.userSubscription.agencyCustomerData) {
        return;
    }

    const { customer_id, provider_subscription_id } = this.userSubscription.agencyCustomerData;

    if (!customer_id || !provider_subscription_id) {
      NotifierComponent.notify(new Notification('Missing subscription information', NotificationType.DANGER));
      return;
    }

    const expirationDate = this.userSubscription.nextBillingDate ?
      new Date(this.userSubscription.nextBillingDate).toLocaleDateString('en-US', {
        year: 'numeric', 
        month: 'short', 
        day: 'numeric' 
      }) : 'the expiration date';

    const confirmDialog = this._dialogService.addDialog(ConfirmDialogComponent, {
      header: TextUtils.getText('text_cancelSubscriptionTitle'),
      message: TextUtils.getText('text_cancelSubscriptionDesc') + '<br/><br/><div class="db-banner"><i class="db-icon db-icon-ds-time-on"></i>' + TextUtils.getText('text_cancelSubscriptionSubDesc') + `<span>${expirationDate}.</span></div>`,
      cancelButtonText: TextUtils.getText('text_cancel'),
      cancelButtonClass: 'ds-btn-white-gray-border',
      confirmButtonText: TextUtils.getText('text_proceed'),
      confirmButtonClass: 'ds-btn-black',
      width: '500px',
        height: '268',
      alignLeft: true,
      buttonWidth: '82px',
      alignButtonsRight: true
    });

    confirmDialog.subscribe((isConfirmed) => {
      if (isConfirmed) {
        this.loading = true;
        this._workspaceService.toggleSubscription(this.user.id)
          .pipe(
            filter((response: DbResponse): boolean => !!response),
            first()
          )
          .subscribe((response: DbResponse): void => {
            if (response.success) {
             setTimeout(() => {
                 this.loadData(true);
                 NotifierComponent.notify(new Notification(response.message || 'Subscription canceled successfully', NotificationType.SUCCESS));
             }, 6000);

            } else {
              NotifierComponent.notify(new Notification(response.message || 'Failed to cancel subscription', NotificationType.DANGER));
              this.loading = false;
            }
          });
      }
    });
  }

  public activateUserSubscription(): void {
      this.loading = true;
      this._workspaceService.toggleSubscription(this.user.id)
          .pipe(
              filter((response: DbResponse): boolean => !!response),
              first()
          )
          .subscribe((response: DbResponse): void => {
              if (response.success) {
                  setTimeout(() => {
                      NotifierComponent.notify(new Notification(response.message || 'Subscription activated successfully', NotificationType.SUCCESS));
                      this.loadData(true);
                  }, 6000);
              } else {
                  NotifierComponent.notify(new Notification(response.message || 'Failed to cancel subscription', NotificationType.DANGER));
                  this.loading = false;
              }
          });
  }

  public renewUserSubscription(userSubscription: UserSubscription, renew: boolean = false, fromDomainBanner = false): void {
    this._dialogService
      .addDialog(PaymentDialogComponent, {
        upgradeSubscription: this.userSubscription,
        fromDialog: false,
        renew: true,
        activate: !renew,
        renewCouponCode: this.userSubscription && this.userSubscription.platformPaidClient && (!this.payments || this.payments.length === 0) && this.userSubscription.isExpired ? 'BLK50' : this.userSubscription && this.userSubscription.trialClient && this.userSubscription.isExpired ? 'BLK50OFF' : ''

      })
      .subscribe((reopenLast: boolean): void => {
        if (reopenLast) {
          this.loadData(true);
        }
      });
  }


  public renewSubscription(unpauseUser: boolean = true): void {
    if (!unpauseUser) return;
    this.activateClicked = true;
    this._dialogService
      .addDialog(PaymentDialogComponent, {
        upgradeSubscriptionId: this.userSubscription?.plan?.agency_pricing_plan_id,
        fromDialog: false,
        renew: true
      })
      .subscribe((isConfirmed: boolean) => {
        if (isConfirmed) {
          setTimeout(() => {
              this.loadData(true);
              this.activateClicked = false;
          }, 6000);
        } else {
          this.activateClicked = false;
        }
      });
  }

  private _renewAfterPaused(cardId): void {
    const paypalRecurring = this.userSubscription.paymentType !== 'card';
    this._workspaceService.renewSubscription(this.user.agreementId, cardId, paypalRecurring ? 'paypal_recurring' : 'card', this.userSubscription.subscriptionTitle)
      .pipe(filter((response: DbResponse): boolean => !!response),
        first())
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          this.loading = false;
          if (paypalRecurring && response.data.result.approval_link) {
            window.location.href = response.data.result.approval_link;
          } else if (response.data && response.data.result && response.data.result.requires_source_action) {
            this._handleAction(response.data, 'renew');
          } else {
            this._welcomeBackAfterUnpause();
            this.activateClicked = false;
            this.loadData(true);
            this.removeEventHandlers();
            this._router.navigate(['/workspace/subscription-plan'], {queryParams: {'update_subscr': 1}});
          }
        } else {
          this.activateClicked = false;
          this.loading = false;
        }
      });
  }

  showPricingDialog(): void {
   const modal = this._dbModal.open(PricingPageViewComponent, { overflowHidden: true, height: 960, width: 1076});
    modal.componentInstance.user = this.user;
  }

  private _welcomeBackAfterUnpause(): void {
    let currentDate = new Date();
    // Add 7 days to the current date
    this.nextPaymentDate.setDate(currentDate.getDate() + 7);

    this._dialogService.addDialog(NotificationDialogComponent, {
      header: 'Welcome Back!',
      message: TextUtils.getText('text_welcomeBackDesc', {
        date: Utils.formatDate(this.nextPaymentDate, 'dd MMM, y')
      }),
      width: 700,
      buttonText: 'Continue',
      buttonColor: 'black',
      buttonAlign: 'right',
      hasCloseButton: true,
      hasGradientBorder: true,
      textAlign: 'left'
    });
  }

  private _handleAction(_data, action) {
    this.loading = true;
    this._stripe.handleCardAction(_data['client_secret'] || _data.result['client_secret'] || _data.result['payment_status']).then((result) => {
      if (result.error && result.error.payment_intent) {
        this._confirmClientStripe(result.error.payment_intent.id, action, _data);
      } else {
        // The card action has been handled
        // The PaymentIntent can be confirmed again on the server
        this._confirmClientStripe(result.paymentIntent.id, action, _data);
      }
    });
  }

  private _confirmClientStripe(id, action, _data?): void {
    this._authService.confirmStripe(id, action)
      .pipe(
        filter((response: DbResponse): boolean => !!response),
        first())
      .subscribe((response) => {
        this.loading = false;
        this.activateClicked = false;
        this._welcomeBackAfterUnpause();
        this.loadData(true);
      });
  }


  private addEventHandlers(): void {
    this.subscriptions = [];

    this.subscriptions.push(this._router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.loadData();
    }));

    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getUser),
          this._store.select(fromStore.getUserAvailableHostingSubscriptions()),
          this._store.select(fromStore.getUserUpgradableSubscription()),
          this._store.select(fromStore.getUserAvailableSubscription((this.userSubscription && this.userSubscription.plan.shortFeatures.newPlan ? Config.aiStarterAnnual : Config.aiStarterAnnual), true))
        )),
        first()
      )
      .subscribe(([user, availableHostingSubscriptions, userUpgradableSubscription, firstAnnualPlan]) => {
        this.user = user;
        this.upgradeSubscription = userUpgradableSubscription;
        this.aiStarterAnnual = firstAnnualPlan;
        this.hasUpgrade = !!userUpgradableSubscription && !(availableHostingSubscriptions.length === 1 && availableHostingSubscriptions.filter((_userSubscription => _userSubscription.tabCategory === this.userSubscription.tabCategory)));
      });
  }

  public upgradeWithCoupon(): void {
    if (this.promoCode.length) {
      this.loading = true;
      this._workspaceService.upgradeWithCoupon(this.promoCode).pipe(
        filter((response: DbResponse): boolean => !!response),
        first()
      ).subscribe((response: DbResponse): void => {
        this.loading = false;
        this.promoCode = '';
        let headerText: string;
        let messageText: string;
        let buttonText: string;
        if (response.success) {
          headerText = TextUtils.getText('text_addPaymentMethodSubscriptionSuccessTitle');
          messageText = TextUtils.getText('text_addPaymentMethodSubscriptionSuccessMessage');
          buttonText = TextUtils.getText('text_addPaymentMethodSubscriptionSuccessButton');
          this.loadData(true);
        } else {
          headerText = TextUtils.getText('text_uploadFail');
          messageText = TextUtils.getText('text_addPaymentMethodSubscriptionFailMessage');
          buttonText = TextUtils.getText('text_addPaymentMethodSubscriptionFailButton');
        }
        this._dialogService
          .addDialog(CouponApplyResponseDialogComponent, {
            headerText: headerText,
            messageText: messageText,
            buttonText: buttonText,
          });
      });
    }
  }

  private getPaymentMethods(): void {
    this.loading = true;
    let paymentMethods = null;

    this._store.select(fromStore.getUserPaymentMethodsLoaded)
      .pipe(
        switchMap(() => this._store.select(fromStore.getUserPaymentMethods))
      )
      .subscribe(data => {
        if (data && !TypeUtils.isNull(data)) {
          paymentMethods = Utils.sort(data, (a: Product, b: Product): number => {
            return a.active === b.active ? 0 : (b.active && !a.active ? 1 : -1);
          });
          this.paymentMethods = paymentMethods;
        }
        this.loading = false;
      });
  }

  private _getCompanyInfo(): void {
    this._store.select(fromStore.getCompanyInfoLoaded)
        .pipe(
            filter((loaded: boolean) => loaded),
            switchMap(() => this._store.select(fromStore.getCompanyInfo)),
            first()
        )
        .subscribe((companyInfo: any) => {
          this.companyInfo = companyInfo;
        });
  }

  private async _initStripe(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      if (window['Stripe']) {
        const stripeConfig: any = {};

        // Support both new payment_provider and old stripe formats
        // New format: companyInfo.payment_provider.account_id (when provider is 'stripe_connect')
        // Old format: companyInfo.stripe.account_id (backward compatibility)
        let stripeAccountId = null;
        if (this.companyInfo?.payment_provider?.provider === 'stripe_connect' && this.companyInfo?.payment_provider?.account_id) {
          stripeAccountId = this.companyInfo.payment_provider.account_id;
        } else if (this.companyInfo?.stripe?.account_id) {
          stripeAccountId = this.companyInfo.stripe.account_id;
        }

        if (stripeAccountId) {
          stripeConfig.stripeAccount = stripeAccountId;
        }

        // Set locale from language service
        const currentLanguage = this._languageService.getCurrentLanguage();
        if (currentLanguage) {
          stripeConfig.locale = currentLanguage;
        }

        this._stripe = window['Stripe'](Config.stripeKey, stripeConfig);
        resolve(true);
      }
      else {
        reject(false);
      }
    });
  }

  private fetchClientSecret = () => {
    console.log('fetchClientSecret called by Stripe');
    // Simulate the fetch request but return the provided client secret
    return new Promise<string>((resolve, reject) => {
      const provider = this.companyInfo?.payment_provider?.provider;
      if (provider === 'paypal') {
        console.log('Making API call to createSetupToken for PayPal');
        this._workspaceService.addPaymentMethod()
            .pipe(
                filter(response => !!response),
                first()
            )
            .subscribe({
              next: (response) => {
                const body = response?.response?.body;

                if (body?.setup_token) {
                  console.log('PayPal provider detected:', {
                    setup_token: body.setup_token,
                    client_token: body.client_token ? 'present' : 'missing'
                  });
                  this.isPayPalProvider = true;
                  this.paypalSetupToken = body.setup_token;
                  resolve('paypal_setup');
                } else {
                  reject(new Error('Invalid PayPal response data'));
                }
              },
              error: (err) => {
                reject(err);
              }
            });
      } else {
        this._workspaceService.addPaymentMethod()
            .pipe(
                filter(response => !!response),
                first()
            )
            .subscribe({
              next: (response) => {
                if (response && response?.response?.body?.setup_intent?.client_secret) {
                  this.isPayPalProvider = false;
                  resolve(response.response.body.setup_intent.client_secret);
                } else if (response && response.response.body.client_secret) {
                  // Fallback to old format
                  this.isPayPalProvider = false;
                  resolve(response.response.body.client_secret);
                } else {
                  reject(new Error('Invalid response data'));
                }
              },
              error: (err) => {
                reject(err);
              }
            });
      }
    });
  }

  public async _initCheckout() {
    try {
      this.checkoutElement = await this._stripe.initCheckout({
        fetchClientSecret: this.fetchClientSecret,
        elementsOptions: {
          savedPaymentMethod: {
            enableRedisplay: 'auto'
          }
        }
      });
    } catch (error) {
      console.error('Error initializing checkout:', error);
    }
  }

  public async addPaymentMethod(activateSubs?: boolean): Promise<void> {
    try {
      this.loadingStripe = true;

      // Check provider BEFORE making API call to avoid double request
      const provider = this.companyInfo?.payment_provider?.provider;

      if (provider === 'paypal') {
        // PayPal flow - fetch setup token
        const clientSecret = await this.fetchClientSecret();
        this._loadPayPalScript();
        this.loadingStripe = false;
        this._dialogService
          .addDialog(AddPaymentMethodComponent, {
            userSubscription: this.userSubscription,
            isPayPalProvider: this.isPayPalProvider,
            paypalSetupToken: this.paypalSetupToken
          })
          .subscribe((isConfirmed: boolean) => {
            if (isConfirmed) {
              this._store.dispatch(new fromStore.LoadUserPaymentMethods());
              if (activateSubs) {
                this.activateUserSubscription();
              }
            }
          });
      } else {
        // Stripe flow - let Stripe call fetchClientSecret via callback
        await this._initStripe();
        await this._initCheckout();
        this.loadingStripe = false;
        this._dialogService
          .addDialog(AddPaymentMethodComponent, {
            userSubscription: this.userSubscription,
            checkout: this.checkoutElement,
            stripe: this._stripe
          })
          .subscribe((isConfirmed: boolean) => {
            if (isConfirmed) {
              this._store.dispatch(new fromStore.LoadUserPaymentMethods());
              if (activateSubs) {
                this.activateUserSubscription();
              }
            }
          });
      }
    } catch (error) {
      console.error('Error in addPaymentMethod:', error);
      this.loadingStripe = false;
      this.stripeErrors = error.message || 'Failed to initialize payment form.';
    }
  }

  ngOnDestroy(): void {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
    this.removeEventHandlers();
  }

  private removeEventHandlers(): void {
    this.subscriptions.forEach((subscription: Subscription): void => {
      subscription.unsubscribe();
    });
    this.subscriptions = null;
  }


  private downgradeAgreementPopup(downgradeTo: string) {
    const modal = this._dbModal.open(ConfirmDowngradeAgreementComponent, {height: 230, width: 700});
    modal.componentInstance.downgradeTo = downgradeTo;
    modal.closed.subscribe(() => {
      const redirectTo = downgradeTo === 'trial' ? '/upgrade-plan' : '/setup';
      this._router.navigate([redirectTo]);
      this._store.dispatch(new fromStore.LoadUser());
      this._store.dispatch(new fromStore.LoadUserSubscription());
      this._store.dispatch(new fromStore.LoadUserAvailableSubscriptions());
    });
    modal.dismissed.subscribe(() => {
      localStorage.removeItem('dbCouponFromEmail');
    });
  }

  private extendAgreement(): void {
    this._workspaceService.extendAgreement()
      .pipe(
        filter(response => !!response),
        first()
      )
      .subscribe(response => {
        if (response.success) {
          this._store.dispatch(new fromStore.LoadUser());
          this._store.dispatch(new fromStore.LoadUserSubscription());
        }
      });
  }

  public sendEvent(action: string, category?, label?): void {
    const analyticsData = {
      eventCategory: TypeUtils.isDefined(category) ? category : 'Dashboard Action',
      eventAction: action,
      eventLabel: TypeUtils.isDefined(label) ? label : 'Subscription Cancellation'
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  private _loadPayPalScript(): void {
    // Check if PayPal SDK is already loaded
    if (window['paypal']) {
      console.log('PayPal SDK already loaded, initializing Card Fields');
      this._initPayPalCardFields();
      return;
    }

    // Get PayPal client ID from companyInfo.payment_provider.account_id
    const clientId = this.companyInfo?.payment_provider?.account_id;

    console.log('PayPal SDK config:', {
      provider: this.companyInfo?.payment_provider?.provider,
      clientId: clientId ? 'present' : 'missing'
    });

    if (!clientId) {
      console.error('PayPal client ID not available in companyInfo.payment_provider');
      this.loadingStripe = false;
      this.stripeErrors = 'PayPal is not configured for this workspace. Please contact your administrator.';
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&components=card-fields&enable-funding=venmo`;
    script.onload = () => {
      console.log('PayPal SDK loaded successfully');
      this._initPayPalCardFields();
    };
    script.onerror = () => {
      console.error('Failed to load PayPal SDK');
      this.loadingStripe = false;
      this.stripeErrors = 'Failed to load PayPal payment system.';
    };
    document.head.appendChild(script);
  }

  private _initPayPalCardFields(): void {
    console.log('Initializing PayPal Card Fields with setup token:', this.paypalSetupToken);
    // PayPal Card Fields will be initialized in the dialog component
  }

}
